var _defs, _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChartExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linechart_export",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".line-cls-2{fill:#c6c6c6;}.line-cls-3{fill:#efeff2;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "background_-_component",
    className: "line-cls-3",
    width: 164,
    height: 132,
    rx: 4,
    ry: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "line-cls-2",
    x: 9,
    y: 11,
    width: 4,
    height: 111,
    rx: 2,
    ry: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "line-cls-2",
    x: 80,
    y: 47,
    width: 4,
    height: 146,
    rx: 2,
    ry: 2,
    transform: "translate(202 38) rotate(90)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pub-primaryColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,96c-.51,0-1.02-.2-1.41-.59-.78-.78-.78-2.05,0-2.83l30.91-30.91,17.5,17.5,27-27,12.5,12.5,42.59-42.59c.78-.78,2.05-.78,2.83,0s.78,2.05,0,2.83l-45.41,45.41-12.5-12.5-27,27-17.5-17.5-28.09,28.09c-.39.39-.9.59-1.41.59Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartExport);
export default __webpack_public_path__ + "static/media/line_chart_export.59660c8cbe5e6fd7e328b1b82dea9390.svg";
export { ForwardRef as ReactComponent };